import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet'; // Import Helmet for managing head tags
import SignupForm from './utils/SignupForm';
import HealthSection from './utils/HealthSection';

const PhysiotherapyTreatmentAndExercisesForNeckPain = () => {
    return (
        <div>
            <Helmet>
                <title>Physiotherapy Treatment and Exercises for Neck Pain | Ramp Physio and Fitness</title>
                <meta name="description" content="Discover effective physiotherapy treatment and exercises for neck pain relief tailored by our experts at Ramp Physio and Fitness in Homebush, NSW." />
            </Helmet>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Expert Neck Pain Relief with Physiotherapy</h1>
                    <h2>Explore our specialized physiotherapy treatments and exercises designed to alleviate neck pain and enhance your mobility.</h2>
                    <p>Neck pain is a common ailment that can significantly impact your daily life. At Ramp Physio and Fitness, our physiotherapy experts specialize in providing personalized treatments and exercises to address neck pain, helping you to regain comfort and function. Our approach is rooted in the latest evidence-based interventions, ensuring you receive the most effective care possible. Let's delve into the world of neck pain physiotherapy and how our services can bring you relief and recovery.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Understanding Neck Pain Causes</h1>
                        <p>Neck pain can stem from a variety of causes, ranging from poor posture to injury. Identifying the underlying cause is crucial for effective treatment. Our physiotherapists conduct detailed assessments to pinpoint the source of your discomfort, whether it's muscle strain, nerve compression, or joint issues.</p>
                        <p>With a clear diagnosis, we tailor a physiotherapy program that targets your specific needs, incorporating techniques such as manual therapy, soft tissue release, and therapeutic exercises. These interventions aim to reduce pain, improve mobility, and strengthen the neck muscles.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/dumbbells.webp" alt="Neck Pain Assessment" />
                    </div>
                </div>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Manual Therapy" />
                </div>
                <div className="service-intro-content2">
                    <h1>Personalized Treatment Plans</h1>
                    <p>Each individual's experience with neck pain is unique, necessitating a customized treatment plan. After a thorough evaluation, our physiotherapists devise a strategy that may include a combination of manual therapy, modalities like ultrasound or TENS, and specific neck exercises.</p>
                    <p>Our goal is to not only alleviate your current pain but also to prevent future occurrences. We focus on education and self-management techniques to empower you to maintain neck health and prevent re-injury.</p>
                </div>
            </div>
            </SkewedContainer>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>

            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Effective Neck Strengthening Exercises</h1>
                    <p>Strengthening the muscles that support the neck is vital for long-term pain relief and function. Our physiotherapists guide you through targeted exercises designed to build strength, enhance stability, and improve posture. These exercises are carefully selected to match your fitness level and recovery stage.</p>
                    <p>Examples of neck strengthening exercises include:</p>
                    <div className="dot-points">
                        <p>• Isometric neck exercises</p>
                        <p>• Gentle range of motion stretches</p>
                        <p>• Chin tucks and neck retraction</p>
                        <p>• Shoulder blade squeezes</p>
                        <p>• Resistance band exercises</p>
                        <p>• Prone cobra pose</p>
                        <p>• Scalene and levator scapulae stretches</p>
                        <p>• Deep neck flexor strengthening</p>
                        <p>• Upper back and core exercises</p>
                        <p>• Breathing techniques for relaxation</p>
                    </div>
                </div>
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Neck Strengthening Exercises" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Pinloaded.webp" alt="Therapeutic Equipment" />
                    </div>
                    <div className="service-intro-content2">
                        <h1>Multifaceted Approach to Neck Pain</h1>
                        <p>Our comprehensive treatment for neck pain encompasses various physiotherapy modalities. We may use heat therapy, cold therapy, or electrical stimulation in conjunction with exercises to optimize your recovery process.</p>
                        <p>Furthermore, we provide ergonomic advice and lifestyle recommendations to support your neck health in daily activities. Our physiotherapists are committed to delivering holistic care that addresses all aspects of your well-being.</p>

                        <br></br>
                        <p>
                            In conclusion, Ramp Physio and Fitness is dedicated to delivering top-tier physiotherapy treatment and exercises for neck pain. Our evidence-based, patient-centered approach ensures that you receive the highest quality of care. If you're struggling with neck pain, our team is ready to help you on your journey to recovery and improved quality of life.
                        </p>
                    </div>
                </div>
            </SkewedContainer>
            <SubpagesLink />

            <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default PhysiotherapyTreatmentAndExercisesForNeckPain;